import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';

@Injectable({
  providedIn: 'root'
})
export class EducationalForumTextService {
  url=ConfigService.toApiUrl("educational-forum-texts/");

  constructor(private http:HttpClient) { }

    getAll(foraId:any){
    return this.http.get<any[]>(`${this.url}?foraId=${foraId}`);
  }
 
  getByState(state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("educational-forum-texts-by-state")}/${state}`,ConfigService.addAction('list'));
  }

  getByProfessorClassroom(classroomId:any,ayId:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("educational-forum-texts-by-professor-classroom")}/${classroomId}/${ayId}`,ConfigService.addAction('list'));
  }

  store(ressource:any){
    return this.http.post<any>(`${this.url}`, ressource,
     ConfigService.addAction('add'));
  }

  update(id:any,ressource:any){
    // apiResource n'expose que PUT|PATCH sur /{id}. Le spoofing par _method
    // fonctionne, mais l'affectation d'une propriete sur un FormData ne cree
    // aucun champ : la requete partait alors en POST nu et repondait 405.
    if (ressource instanceof FormData) {
      ressource.append('_method','PUT');
      return this.http.post<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
    }
    return this.http.put<any>(`${this.url}${id}`, ressource, ConfigService.addAction('edit'));
  }
  delete(id:any){
    return this.http.delete<any>(`${this.url}${id}`,
     ConfigService.addAction('delete'));
  }

  get(id:any){
    return this.http.get<any>(`${this.url}${id}`,
     ConfigService.addAction('show'));
  }

  setState(id:any,state:any){
    return this.http.get<any[]>(`${ConfigService.toApiUrl("educational-forum-texts-set-state")}/${id}/state/${state}`,ConfigService.addAction('status'));
  }
}
